import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  customClass?: string;
}

const CarouselCard: FC<Props> = ({ children, customClass = '' }) => {
  return <div className={customClass}>{children}</div>;
};

export default CarouselCard;
